import type { StyleSpecification } from "mapbox-gl"
import { MAP_STYLES, type MapStyleValue } from "@/components/constants"

const GOOGLE_MAPS_TILE_URL = "https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}"
const MERN_TILE_URL =
	"https://servicesmatriciels.mern.gouv.qc.ca/erdas-iws/ogc/wmts/Imagerie_Continue/Imagerie_GQ/default/GoogleMapsCompatibleExt2:epsg:3857/{z}/{y}/{x}.jpg"

function rasterBaseMapStyle(name: string, tileUrl: string, attribution: string): StyleSpecification {
	return {
		version: 8,
		name,
		glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
		sources: {
			"base-map": {
				type: "raster",
				tiles: [tileUrl],
				tileSize: 256,
				attribution,
			},
		},
		layers: [
			{
				id: "base-map-background",
				type: "background",
				paint: { "background-color": "#f5f5f5" },
			},
			{
				id: "base-map",
				type: "raster",
				source: "base-map",
			},
			{ id: "bottom", type: "slot" },
			{ id: "middle", type: "slot" },
			{ id: "top", type: "slot" },
		],
	}
}

export const BASE_MAP_STYLES = Object.freeze({
	[MAP_STYLES.SIMPLE]: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
	[MAP_STYLES.STANDARD]: "mapbox://styles/mapbox/standard",
	[MAP_STYLES.SATELLITE]: "mapbox://styles/mapbox/satellite-streets-v12",
	[MAP_STYLES.GOOGLE]: rasterBaseMapStyle(
		"Google Maps Satellite",
		GOOGLE_MAPS_TILE_URL,
		'© <a href="https://www.google.com/help/terms_maps/" target="_blank">Google</a>'
	),
	[MAP_STYLES.MERN]: rasterBaseMapStyle(
		"MERN Québec Imagery",
		MERN_TILE_URL,
		'© <a href="https://www.quebec.ca/gouvernement/ministeres-organismes/ressources-naturelles-forets" target="_blank">Gouvernement du Québec</a>'
	),
}) satisfies Readonly<Record<MapStyleValue, string | StyleSpecification>>

const SATELLITE_STYLES: ReadonlySet<MapStyleValue> = new Set([MAP_STYLES.SATELLITE, MAP_STYLES.GOOGLE, MAP_STYLES.MERN])

export function isSatelliteStyle(style: MapStyleValue): boolean {
	return SATELLITE_STYLES.has(style)
}
